// extracted by mini-css-extract-plugin
export default {"icon":"_3qzgZ8v_1sx6qaDPMr5HIr","tooltip":"_2nNVQNUjhfXDFfIxQFsTVI","title":"_1oye-UliE8LoJo5VsPbJX6"};